import React from "react";
import Box from "components/common/Box";
import { usePhcTheme } from "./PhcThemeContext";

const ThemeToggle = () => {
  const { mode, setMode, theme } = usePhcTheme();
  const isDark = mode === "dark";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        p: "4px",
        borderRadius: "999px",
        bgcolor: isDark ? "#000000" : "#F3F4F6",
        border: theme.termToggleBorder,
        flexShrink: 0,
      }}
    >
      {["light", "dark"].map((key) => {
        const active = mode === key;
        return (
          <Box
            key={key}
            component="button"
            type="button"
            aria-pressed={active}
            aria-label={`Switch to ${key} theme`}
            onClick={() => setMode(key)}
            sx={{
              border: 0,
              cursor: "pointer",
              px: { xs: 1.5, md: 2.25 },
              py: 1,
              borderRadius: "999px",
              bgcolor: active
                ? isDark
                  ? "#393939"
                  : "#FFFFFF"
                : "transparent",
              color: active
                ? isDark
                  ? "#FFFFFF"
                  : "#000000"
                : "#6B7280",
              fontWeight: 600,
              fontSize: { xs: 13, md: 14 },
              lineHeight: 1.2,
              whiteSpace: "nowrap",
              boxShadow: active && !isDark ? "0px 1px 2px rgba(0,0,0,0.08)" : "none",
            }}
          >
            {key === "light" ? "Light" : "Dark"}
          </Box>
        );
      })}
    </Box>
  );
};

export default ThemeToggle;
